import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
  name: 'textFormat',
})
export class TextFormatPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  // 针对文本内容中格式信息的转换显示
  transform(value: any, ...args: any[]): any {
    return this.sanitizer.bypassSecurityTrustHtml(value.replace(/[\r\n]/g, '<br/>'));
  }
}
